// Ventisette – öffnet das zugehörige Akkordeon, wenn ein Link auf einen Inhalt darin zeigt
// (Grössen-Link neben der Grössenwahl, Beratungs-Link in der Service-Box).
// Delegiert am document, damit es nach dem Neurendern der Produktsektion weiter greift.
document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[data-ven-size-guide], a[data-ven-enquiry]') : null;
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href'));
  const details = target?.closest('details');
  if (!details) return;
  event.preventDefault();
  details.open = true;
  details.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  details.querySelector('summary')?.focus({ preventScroll: true });
});
